import { jobInfo, submitForm } from "../../../stores/request";
import { useNavigate } from "react-router";
import {
  Box,
  Divider,
  Paper,
  TextField,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
} from "@mui/material";
import StyledHeader from "../../../components/StyledHeader/StyledHeader";
import { useCallback, useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import {
  ArticleOutlined,
  Input,
  CloudUploadOutlined,
  Upload,
} from "@mui/icons-material";
import FastaForm from "../../../components/FastaForm/FastaForm";
import { useSnackbar } from "notistack";


export default function ProteinPrediction(store) {
  // const [useCustomModel, setUseCustomModel] = useState(true);
  const gotoExample = () => {
    window.open("#/result?jobId=2023010290", "_blank");
  };
  const [defaultTask, setDefaultTask] = useState("");
  // const [fasta, setFasta] = useState("");
  const [pdbid, setPdbid] = useState("");
  const [positionX, setPositionX] = useState("");
  const [positionY, setPositionY] = useState("");
  const [positionZ, setPositionZ] = useState("");
  const [fasta, setfasta] = useState("");
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const [uploading, setUploading] = useState(false);
  const [inputFile, setInputFile] = useState(null);
  const [inputFile_molicular, setInputFile_molicular] = useState(null);

  const { enqueueSnackbar } = useSnackbar();
  const [resultData, setResultData] = useState({
    jobId: null,
    requestTime: "2021-09-23 14:36:13",
    status: "waiting",
  });
  const showModal = async (data) => {
    await setResultData({
      jobId: data.jobId,
      requestTime: data.requestTime,
      status: data.status,
    });
    await setIsModalVisible(true);
  };
  const [isModalVisible, setIsModalVisible] = useState(false);

  const submit = async () => {
    let formData = new FormData();
    if (inputFile) {
      formData.append("dataFile", inputFile, inputFile.name);
      formData.append("dataStr", "");
    } else {
      if (fasta.length <= 0) {
        enqueueSnackbar("Please enter the sequence or select one FASTA file", {
          variant: "error",
        });
        return;
      }
      formData.append("dataStr", fasta);
    }

    if (email.length < 1) {
      enqueueSnackbar("Please input your e-mail", { variant: "error" });
      return;
    }

    formData.append("type", 0);
    let submit_param = {
      type: "Affinity ",
      model: "7",
      position: [positionX, positionY, positionZ],
      pdbid: pdbid,
    };
    submit_param = JSON.stringify(submit_param);
    formData.append("param", submit_param);
    formData.append("mail", email);
    enqueueSnackbar("uploading", { variant: "info" });
    // console.log(formData);
    // store.store.servers.request();
    let result = await submitForm(formData);
    console.log(result);
    if (result.success) {
      // store.store.servers.request_success();
      showModal(result.data);
    } else {
      // store.store.servers.request_fail();
      enqueueSnackbar("failed", { variant: "error" });
    }
  };
  useEffect(() => {
    // console.log(defaultTask, fasta);
  }, [defaultTask, fasta]);
  const resetData = useCallback(() => {
    setfasta("");
    setEmail("");
    setDefaultTask("");
  }, []);
  const handleOk = () => {
    setIsModalVisible(false);
    navigate("/tasks");
  };
  return (
    <Box>
      <Dialog open={isModalVisible} onClose={handleOk}>
        <DialogTitle>Your data has been uploaded successfully!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your request time is {resultData.requestTime} and your jobID is{" "}
            {resultData.requestTime.slice(0, 10).split("-").join("") +
              resultData.jobId}{" "}
            please wait.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOk}>OK</Button>
        </DialogActions>
      </Dialog>

      <Paper elevation={3} sx={{ overflow: "hidden", marginTop: 2 }}>
        <StyledHeader icon={<ArticleOutlined />}>
          Input target sequences
        </StyledHeader>
        <Grid container direction="row">
          <Grid item xs={2.6} sx={{ p: 1.5 }}>
            <TextField
              value={pdbid}
              onChange={({ target: { value } }) => {
                setPdbid(value);
              }}
              variant="outlined"
              label={"PDB ID"}
              multiline
              fullWidth
              rows={1}
              sx={{ margin: "20px 0" }}
            />{" "}
          </Grid>
          <Grid item xs={2.6} sx={{ p: 1.5 }}>
            <TextField
              value={positionX}
              onChange={({ target: { value } }) => {
                setPositionX(value);
              }}
              variant="outlined"
              label={"Coordinate X"}
              multiline
              fullWidth
              rows={1}
              sx={{ margin: "20px 0" }}
            />{" "}
          </Grid>
          <Grid item xs={2.6} sx={{ p: 1.5 }}>
            <TextField
              value={positionY}
              onChange={({ target: { value } }) => {
                setPositionY(value);
              }}
              variant="outlined"
              label={"Coordinate Y"}
              multiline
              fullWidth
              rows={1}
              sx={{ margin: "20px 0" }}
            />{" "}
          </Grid>

          <Grid item xs={2.6} sx={{ p: 1.5 }}>
            <TextField
              value={positionZ}
              onChange={({ target: { value } }) => {
                setPositionZ(value);
              }}
              variant="outlined"
              label={"Coordinate Z"}
              multiline
              fullWidth
              rows={1}
              sx={{ margin: "20px 0" }}
            />{" "}
          </Grid>
          <Grid item xs={1.6} sx={{ pt:5 }}>
            <Button onClick={()=>{
              setPdbid("1iep")
              setPositionX("15.190")
              setPositionY("53.903")
              setPositionZ("16.917")
            }}>
              Example
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={3} sx={{ overflow: "hidden", marginTop: 2 }}>
        <StyledHeader icon={<ArticleOutlined />}>
          Input molecule SMILES
        </StyledHeader>

        <Box padding={2}>
          <Divider sx={{ marginBottom: 2 }} />
          <FastaForm
            fasta={fasta}
            setFasta={setfasta}
            annotation={true}
            type="Affinity"
            setInputFile={setInputFile_molicular}
            molecule={true}
          />
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ marginTop: 2, overflow: "hidden" }}>
        <StyledHeader icon={<CloudUploadOutlined />}>Submission</StyledHeader>
        <Box margin={2}>
          <TextField
            value={email}
            onChange={({ target: { value } }) => {
              setEmail(value);
            }}
            label="E-mail address"
            fullWidth
            sx={{ mb: 2 }}
          />
          <Typography variant="body2" component="div" marginBottom={2}>
            Model training usually takes a long time, depending on the size of
            the data. Hence, we strongly recommend you to leave your e-mail
            address below so that you will be notified by email when the job is
            done.
          </Typography>
          <Box marginTop={2}>
            <LoadingButton
              onClick={submit}
              loading={uploading}
              variant="contained"
              loadingPosition="start"
              startIcon={<Upload />}
            >
              submit
            </LoadingButton>
            <Button
              onClick={gotoExample}
              variant="contained"
              color="secondary"
              sx={{ marginLeft: 1 }}
            >
              example result
            </Button>
            <Button
              onClick={resetData}
              color="error"
              variant="outlined"
              sx={{ marginLeft: 1 }}
            >
              reset
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}
